import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { PreOrPostAssessmentGraphOfData } from 'projects/shared/src/models/trainer/training-course-details/PreOrPostAssessmentGraphOfData';
import { ScoreChangesPerSlide } from 'projects/shared/src/models/trainer/training-course-details/ScoreChangesPerSlide';
import { TraineePreAssessmentReportCard } from 'projects/shared/src/models/trainer/training-course-details/TraineePreAssessmentReportCard';
import { TraineeProgressDiagram } from 'projects/shared/src/models/trainer/training-course-details/TraineeProgressDiagram';
import { TraineeScoreChanges } from 'projects/shared/src/models/trainer/training-course-details/TraineeScoreChanges';
import { FinalAssessmentType } from 'projects/shared/src/models/trainer/training-courses-list/enums/ContentType';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { DChart } from 'projects/admin/src/app/features/dashboard/models/DChart';
import { AssessmentType } from 'projects/shared/src/models/trainer/training-course-details/AssessmentType';
import { CoursesService } from 'projects/shared/src/services/Courses.service';

export interface DialogData {
  courseId: number;
  moduleId: number;
  foTrainer: boolean;
  forFinalAssessment: boolean;
}

@Component({
  selector: 'app-assessment-results-pathologists',
  templateUrl: './assessment-results-pathologists.component.html',
  standalone: false
})
export class AssessmentResultsPathologistsComponent implements OnInit {

  dataLoading = false;
  traineePreAssessmentReportCard: TraineePreAssessmentReportCard = new TraineePreAssessmentReportCard();
  traineePostAssessmentReportCard: TraineePreAssessmentReportCard = new TraineePreAssessmentReportCard();
  preAssessmentGraphOfData: PreOrPostAssessmentGraphOfData = new PreOrPostAssessmentGraphOfData();
  postAssessmentGraphOfData: PreOrPostAssessmentGraphOfData = new PreOrPostAssessmentGraphOfData();
  scoreChangesPerSlide: ScoreChangesPerSlide[] = [];
  traineeScoreChanges: TraineeScoreChanges[] = [];
  finalAssessmentGraph: PreOrPostAssessmentGraphOfData = new PreOrPostAssessmentGraphOfData();
  finalAssessmentForTrainee: PreOrPostAssessmentGraphOfData = new PreOrPostAssessmentGraphOfData();
  traineeProgressDiagram: TraineeProgressDiagram[] = [];
  finalAssessmentType = FinalAssessmentType
  charts: DChart[] = [];
  // @ViewChild('content') content: ElementRef;
  loadingExport = false;
  @ViewChild('dataToExport', { static: false }) public dataToExport: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<AssessmentResultsPathologistsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private swalService: SwalService,
    private service: CoursesService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.foTrainer && !this.data.forFinalAssessment) {
      this.getPreAssessmentGraphOfData();
    } else if (this.data && this.data.foTrainer && this.data.forFinalAssessment) {
      this.getFinalAssessmentGraph();
    } else if (this.data && !this.data.foTrainer && this.data.forFinalAssessment) {
      this.getFinalAssessmentGraphForTrainee();
    } else if (this.data && this.data.moduleId) {
      this.getTraineeProgressDiagram();
    } else {
      this.getTraineePreAssessmentReportCard();
    }
  }

  getTraineeProgressDiagram() {
    this.dataLoading = true;
    this.service.getTraineeProgressDiagram(this.data.moduleId).subscribe(
      data => {
        if (data) {
          this.traineeProgressDiagram = data as TraineeProgressDiagram[];
        }
        this.dataLoading = false;
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getFinalAssessmentGraph() {
    this.dataLoading = true;
    this.service.getFinalAssessmentGraph(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.finalAssessmentGraph = data as PreOrPostAssessmentGraphOfData;
          this.finalAssessmentChart(this.finalAssessmentGraph.traineeOverallScores, 'name', this.translate.instant('courseDetails.finalAssessment'), 'col-lg-12');
          //this.PreOrPostChart('', 'col-xxl-6 col-xl-6 col-lg-6', this.finalAssessmentGraph, 'traineeName');
        }
        this.dataLoading = false;
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getFinalAssessmentGraphForTrainee() {
    this.dataLoading = true;
    this.service.getFinalAssessmentGraphForTrainee(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.finalAssessmentForTrainee = data as PreOrPostAssessmentGraphOfData;
        }
        this.dataLoading = false;
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getTraineePreAssessmentReportCard() {
    this.dataLoading = true;
    this.service.getTraineePreAssessmentReportCard(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.traineePreAssessmentReportCard = data as TraineePreAssessmentReportCard;
        }
        this.getTraineePostAssessmentReportCard();
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getTraineePostAssessmentReportCard() {
    this.service.getTraineePostAssessmentReportCard(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.traineePostAssessmentReportCard = data as TraineePreAssessmentReportCard;
        }
        this.dataLoading = false;
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getPreAssessmentGraphOfData() {
    this.dataLoading = true;
    const query = {
      CourseId: this.data.courseId,
      ModuleType: AssessmentType.PRE_ASSESSMENT
    };
    this.service.getPreOrPostAssessmentGraphOfData(query).subscribe(
      data => {
        if (data) {
          this.preAssessmentGraphOfData = data as PreOrPostAssessmentGraphOfData;
        }
        this.getPostAssessmentGraphOfData();
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  getPostAssessmentGraphOfData() {
    const query = {
      CourseId: this.data.courseId,
      ModuleType: AssessmentType.POST_ASSESSMENT
    };
    this.service.getPreOrPostAssessmentGraphOfData(query).subscribe(
      data => {
        if (data) {
          this.postAssessmentGraphOfData = data as PreOrPostAssessmentGraphOfData;
        }
        this.calculateTraineeScoreChanges();
      },
      error => {
        this.dataLoading = false;
      }
    );
  }


  calculateTraineeScoreChanges() {
    this.service.calculateTraineeScoreChanges(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.traineeScoreChanges = data as TraineeScoreChanges[];
          this.PreOrPostChart('', 'col-xxl-6 col-xl-6 col-lg-6', this.traineeScoreChanges, 'traineeName');
          this.changeChart(this.traineeScoreChanges, 'traineeName', this.translate.instant('quiz.change') + '%', 'col-xxl-6 col-xl-6 col-lg-6');
        }
        this.calculateUserScoreChangesPerSlide();
      },
      error => {
        this.dataLoading = false;
      }
    );
  }


  calculateUserScoreChangesPerSlide() {
    this.service.calculateUserScoreChangesPerSlide(this.data.courseId).subscribe(
      data => {
        if (data) {
          this.scoreChangesPerSlide = data as ScoreChangesPerSlide[];
          this.PreOrPostChart('', 'col-xxl-8 col-xl-8 col-lg-8', this.scoreChangesPerSlide, 'slideName');
          this.changeChart(this.scoreChangesPerSlide, 'slideName', this.translate.instant('quiz.change') + '%', 'col-xxl-4 col-xl-4 col-lg-4');
        }
        this.dataLoading = false;
      },
      error => {
        this.dataLoading = false;
      }
    );
  }

  PreOrPostChart(label, colums, records, keyName) {
    const recordData = {
      title: label,
      colums,
      showLegend: true,
      showYAxis: true,
      xAxisLabel: '',
      yAxisLabel: '',
      type: 'multi',
      values: [],
      colorScheme: {
        domain: ['#3E8484', '#4EA5A5', '#8CC5C5', '#D3E9E9', '#B8DBDB']
      },
      customClassCard: 'shadow-none border'
    } as DChart;
    records.map(obj => {
      recordData.values?.push(
        {
          name: obj[keyName],
          series: [
            {
              name: this.translate.instant('slides.preAssessment'),
              value: obj.preScore,
              extra: {
                label: obj.preScore + '%'
              }
            },
            {
              name: this.translate.instant('slides.postAssessment'),
              value: obj.postScore,
              extra: {
                label: obj.postScore + '%'
              }
            }
          ]
        }
      );
    });

    this.charts.push(recordData);
  }

  finalAssessmentChart(records, keyName, label, colums) {
    const recordData = {
      title: label,
      colums,
      showLegend: false,
      showYAxis: true,
      values: [],
      colorScheme: {
        domain: ['#3E8484', '#4EA5A5', '#8CC5C5', '#D3E9E9', '#B8DBDB']
      },
      customClassCard: 'shadow-none border'
    } as DChart;
    records.map(obj => {
      recordData.values?.push(
        {
          name: obj.key[keyName],
          value: obj.value,
          extra: {
            label: obj.value + '%'
          }
        }
      );
    });
    this.charts.push(recordData);
  }

  changeChart(records, keyName, label, colums) {
    const recordData = {
      title: label,
      colums,
      showLegend: false,
      showYAxis: true,
      values: [],
      colorScheme: {
        domain: ['#3E8484', '#4EA5A5', '#8CC5C5', '#D3E9E9', '#B8DBDB']
      },
      customClassCard: 'shadow-none border'
    } as DChart;
    records.map(obj => {
      recordData.values?.push(
        {
          name: obj[keyName],
          value: obj.changePercentage,
          extra: {
            label: obj.changePercentage + '%'
          }
        }
      );
    });
    this.charts.push(recordData);
  }

  printPage() {
    // window.print();
    this.loadingExport = true;
    // const content = document.getElementById('progressEleme'); // Replace 'pdfContent' with the ID of the HTML element you want to export

    setTimeout(() => {
      html2canvas(this.dataToExport.nativeElement).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const width = this.dataToExport.nativeElement.clientWidth;
        const height = this.dataToExport.nativeElement.clientHeight + 40;
        let orientation = '';
        let imageUnit = 'pt';
        if (width > height) {
          orientation = 'l';
        } else {
          orientation = 'p';
        }
        let jsPdfOptions = {
          orientation: orientation,
          unit: imageUnit,
          format: [width + 50, height + 220]
        } as any;
        const pdf = new jsPDF(jsPdfOptions);
        pdf.addImage(imgData, 'PNG', 0, 0, width, height);
        pdf.save('exported.pdf');
        this.loadingExport = false;
      });
    }, 100);
  }

  handleErrors(errors) {
    errors = JSON.parse(errors);
  }
}
